import gql from 'graphql-tag';

// Translation source for the Force Guarantee row-context launch: the ineligible
// purchase row carries the order's public `externalId`, while the force lookup
// and the eligibility check operate on APMS's internal `orderId`. This is the
// only query exposing both, and it sits under the same policy as the rest of
// the flow, so it needs no additional role.
const ruleEvaluationOrdersQuery = gql`
  query RuleEvaluationOrders($vin: String!) {
    ruleEvaluationOrders(vin: $vin) {
      orderId
      externalId
    }
  }
`;

export default ruleEvaluationOrdersQuery;
